import React, { useState, useEffect } from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import "./Timeline.css";
import EventService from "../../../services/EventService";
import useViewer from "../../../hooks/useViewer";
import { HeadingContainer } from "../../../styles/component/style";
import VideoBox from "../../common/VideoBox";
import { navigate, useLocation } from "@reach/router";
import useLoader from "../../../hooks/useLoader";
import { DrawerContainer } from "../Register";
import VideoPlayer from "../../common/Video";
import CustomAudioPlayer from "../../schedules/AudioPlayer/CustomAudioPlayer";
import CustomAudioPlayerImage from "../../schedules/AudioPlayer/CustomAudioPlayerImage";
import { HeroContainerWrap, WidthMax, HeroContainer } from "../Register";

const GalleryViewLive = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { userObject, setGlobalState } = useViewer();
  const [userData, setUserData] = useState();
  const location = useLocation();
  const { setLoader } = useLoader();

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching live..." });
        const response = await EventService.eventInfoEventViewerLive(
          userObject?.eventId,
          "live",
        );
        setUserData(response);
        setGlobalState(response);
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
        if (err.errorCode === "ER-UNAUTHORISED-USER") {
          navigate(location.pathname);
        }
      } finally {
        setLoader({ state: false });
      }
    }
    if (userObject?.eventId) {
      getEventInfo();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userObject?.eventId]);

  useEffect(() => {
    if (userObject?.eventId) {
      const interval = setInterval(() => {
        (async function getEventInfo() {
          try {
            const response = await EventService.eventInfoEventViewerLive(
              userObject?.eventId,
              "live",
            );
            setUserData(response);
            setGlobalState(response);
          } catch (err) {
            if (err.errorCode === "ER-UNAUTHORISED-USER") {
              navigate(location.pathname);
            }
          }
        })();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [userObject?.eventId]); // eslint-disable-line react-hooks/exhaustive-deps

  const { galleryView } = userData?.livepage || {};
  // Define condition in a variable

  return (
    <>
      <WidthMax id="about">
        <HeroContainerWrap id="hero">
          <HeroContainer>
            <Center>
              {userData?.general?.eventStatus === "inactive" &&
              (userData?.general?.playbackInfo?.playbackRequired === false ||
                !userData?.general?.playbackInfo?.playbackRequired) ? (
                <OuterContainer>
                  <DrawerContainer>
                    <h2>Your event is inactive</h2>
                  </DrawerContainer>
                </OuterContainer>
              ) : (
                <OuterContainer
                  checkAgm={galleryView?.showHeader ? true : false}
                >
                  {userData?.general?.eventStatus === "inactive" &&
                  userData?.general?.playbackInfo?.playbackRequired &&
                  !userData?.general?.playbackInfo?.playbackVideo?.length ? (
                    <DrawerContainer>
                      <h2>Playback is getting ready for this event</h2>
                    </DrawerContainer>
                  ) : userData?.general?.eventStatus === "inactive" &&
                    userData?.general?.playbackInfo?.playbackRequired &&
                    userData?.general?.playbackInfo?.playbackVideo?.length ? (
                    <Container>
                      <VideoWrapper>
                        {userData?.general?.playbackInfo?.playbackVideo && (
                          <VideoPlayer
                            src={userData?.general?.playbackInfo?.playbackVideo}
                          />
                        )}
                      </VideoWrapper>
                    </Container>
                  ) : (
                    <Container>
                      {userData?.general?.eventTitle ? (
                        <HeadingContainer>
                          {/* <Header3
                            style={{
                              color:
                                userData?.theme?.themeGeneral?.titleTextColor,
                              fontFamily:
                                userData?.theme?.themeGeneral?.titleTextFont,
                              fontSize: `${userData?.theme?.themeGeneral?.titleTextFontSize}px`,
                            }}
                          >
                            {userData?.general?.eventTitle}
                          </Header3> */}
                        </HeadingContainer>
                      ) : null}
                      {userData?.livepage?.livePageSettings?.contentFormat ===
                      "video"
                        ? userData?.livepage?.liveStreamSettings
                            .filter((item) => item?.label === "Live Stream")
                            .map((stream) => (
                              <VideoCard>
                                <VideoBox
                                  src={
                                    stream?.liveStreamPlayerUrl
                                      ? stream?.liveStreamPlayerUrl
                                      : ""
                                  }
                                />
                              </VideoCard>
                            ))
                        : userData?.livepage?.livePageSettings
                            ?.contentFormat === "audio"
                        ? userData?.livepage?.liveStreamSettings
                            .filter((item) => item?.label === "Live Stream")
                            .map((stream) => (
                              <CustomAudioPlayer
                                src={
                                  stream?.liveStreamPlayerUrl
                                    ? stream?.liveStreamPlayerUrl
                                    : ""
                                }
                              />
                            ))
                        : userData?.livepage?.livePageSettings
                            ?.contentFormat === "audioWithStaticImage"
                        ? userData?.livepage?.liveStreamSettings
                            .filter((item) => item?.label === "Live Stream")
                            .map((stream) => (
                              <CustomAudioPlayerImage
                                image={
                                  userData?.livepage?.livePageSettings
                                    ?.uploadStaticImg
                                }
                                src={
                                  stream?.liveStreamPlayerUrl
                                    ? stream?.liveStreamPlayerUrl
                                    : ""
                                }
                              />
                            ))
                        : null}
                    </Container>
                  )}
                </OuterContainer>
              )}
            </Center>
          </HeroContainer>
        </HeroContainerWrap>
      </WidthMax>
    </>
  );
};

export default GalleryViewLive;

export const OuterContainer = styled.div`
  width: 100%;
  min-height: 80vh;
  justify-content: center;
  align-items: center;
  padding-top: ${({ checkAgm }) => (checkAgm ? "0px" : "30px")};
  padding-bottom: 10px;
  @media ${theme.breakpoints.sm_up} {
    min-height: 90vh;
  }
`;

export const Container = styled.div`
  border-radius: 11px;
  width: 100%;
  margin: 20px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 600px) {
    width: 90%;
    padding: 30px 30px;
  }
  @media ${theme.breakpoints.sm_up} {
    width: 100%;
  }
`;

const VideoCard = styled.div`
  display: flex;
  margin: 28px 0;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  @media${theme.breakpoints.sm_up} {
    width: 70%;
  }
  @media ${theme?.breakpoints?.lg_up} {
    align-items: space-between;
    margin-right: 50px;
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media${theme.breakpoints.sm_up} {
    width: 90%;
    padding-right: 18px;
  }
  @media ${theme?.breakpoints?.lg_up} {
    width: 85%;
    margin-left: 68px;
  }
`;

export const AboutUsBody = styled.section`
  /* height: 663px; */
  background-color: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 600px) {
    height: unset;
  }
`;
export const GreySection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 60px 0 60px 0;
  align-items: center;
  background-color: #f9f9f9;
  width: 100vw;
`;
export const WhiteSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
`;

export const H2 = styled.h2`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  font-size: 22px;
  margin-bottom: 32px;
  cursor: default;
  padding: 0 20px;
  margin: 0 auto;
  @media (max-width: 1024px) {
    font-size: 24px;
    text-align: center;
  }
`;

export const BodyWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  padding: 1%;
  color: ${COLORS.BTN_GREEN};
  font-family: ${theme.fonts.primaryFontBold};
  width: 100%;
  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const Loader = styled.div`
  align-items: center;
  justify-content: center;
`;

const Center = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  @media only screen and (max-width: 767px) {
    margin-left: 12px;
  }
`;
